import React, { useRef } from 'react';

type UncontrolledFormProps = {
    submitForm?: (formElement: HTMLFormElement, formData: { [p: string]: FormDataEntryValue }) => void;
    children: React.ReactNode;
    id: string;
};

/**
 * @deprecated prefer using Form from Atlas instead
 */
export function UncontrolledForm({ submitForm, children, id }: UncontrolledFormProps) {
    const uncontrolledFormRef = useRef<HTMLFormElement>(null);
    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.stopPropagation();
        e.preventDefault();
        const formElement = uncontrolledFormRef.current;
        if (formElement) {
            const formData = new FormData(formElement);
            const data = Object.fromEntries(formData.entries());
            submitForm?.(formElement, data);
        }
    };

    return (
        <form ref={uncontrolledFormRef} id={id} onSubmit={onSubmit}>
            {children}
        </form>
    );
}
